<template>
  <div :class="[$style.container, mode === 'popup' && $style.popup]">
    <!-- 普通模式 -->
    <template v-if="mode === 'normal'">
      <Loading :loading="loading" text="添加中...">
        <Item title="姓名">
          <el-input v-model="realName" />
        </Item>

        <Item title="证件类型">
          <el-select v-model="type" value-key="id">
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </Item>

        <Item title="证件号码">
          <el-input v-model="number" />
        </Item>

        <Item title="身份证正面照">
          <UploadImage :imageUrl="imageUrl" @change="onFileChange" />
        </Item>

        <Item title=" ">
          <Button type="primary" @click="clickSubmit">添加</Button>
        </Item>
      </Loading>
    </template>

    <!-- 弹窗模式 -->
    <el-dialog
      v-if="mode === 'popup'"
      :custom-class="$style.dialog"
      title="添加实名认证"
      :visible="visible"
      @close="close"
    >
      <Loading :loading="loading" text="添加中...">
        <Item title="姓名">
          <el-input v-model="realName" />
        </Item>

        <Item title="证件类型">
          <el-select v-model="type" value-key="id">
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </Item>

        <Item title="证件号码">
          <el-input v-model="number" />
        </Item>

        <Item title="身份证正面照">
          <UploadImage :imageUrl="imageUrl" @change="onFileChange" />
        </Item>

        <Item title=" ">
          <Button type="primary" size="small" @click="clickSubmit">添加</Button>
          <Button size="small" :class="$style.btn_cancel" @click="close">
            取消
          </Button>
        </Item>
      </Loading>
    </el-dialog>
  </div>
</template>

<script>
import { createIdentify } from "@server";

import UploadImage from "@components/UploadImage.vue";

export default {
  name: "RealNamePopup",
  components: {
    UploadImage,
  },
  props: {
    mode: {
      // normal - 普通模式 ，popup - 弹窗模式
      type: String,
      default: "normal",
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      realName: "", // 姓名
      typeList: [
        {
          value: 0,
          label: "身份证",
        },
        {
          value: 1,
          label: "护照",
        },
      ],
      type: 0, // 证件类型
      number: "", //  证件号码

      file: null, // 证件图片文件
      imageUrl: "", // 证件图片url

      loading: false,
    };
  },
  methods: {
    onFileChange(data) {
      this.file = data.file;
      this.imageUrl = data.imageUrl;
    },

    checkSubmit() {
      if (!this.realName) {
        this.$message({ message: "请输入真实姓名！", type: "warning" });
        return false;
      }

      if (!this.number) {
        this.$message({ message: "请输入正确的证件号码！", type: "warning" });
        return false;
      }

      if (!this.file) {
        this.$message({ message: "请上传证件正面图片！", type: "warning" });
        return false;
      }

      return true;
    },

    async clickSubmit() {
      if (!this.checkSubmit()) return;

      this.loading = true;

      let data = new FormData();
      data.append("username", this.realName);
      data.append("type", this.type);
      data.append("cardNum", this.number);
      data.append("confirmNumber", this.number);
      data.append("file", this.file);

      const res = await createIdentify(data);

      if (res.code === 200) {
        this.$message({ message: "认证成功", type: "success" });
        this.$emit("success");
        this.close();
      } else {
        this.$message({ message: res.message, type: "error" });
      }
      this.loading = false;
    },

    close() {
      this.realName = "";
      this.type = 0;
      this.number = "";
      this.file = null;
      this.imageUrl = "";
      this.$emit("close");
    },
  },
  mounted() {},
};
</script>

<style lang="scss" module scoped>
.container {
  background: $white;

  :global {
    ::v-deep .gl-item {
      margin-bottom: rem(40);
      .gl-item__left {
        width: rem(120);
        flex-shrink: 0;
      }
    }

    .el-input {
      width: rem(280);
    }
  }

  /* 以下为实名认证弹窗模式样式 */
  .popup {
  }

  ::v-deep .dialog {
    width: auto;

    :global {
      .el-dialog__header {
        padding: 10px rem(50);

        .el-dialog__title {
          font-size: max(rem(20), 16px);
          color: #333;
          line-height: 32px;
        }
      }
      .el-dialog__body {
        padding: rem(50);
      }
    }
  }

  .btn_cancel {
    color: $white;
    background-color: #777777;
    margin-left: rem(10);
  }
}
</style>
